import { PageProps } from '@/types';
import React, { useEffect } from "react";
import { Person } from "@/types/person";
import { MetaTag } from "@/types/MetaTab";
import moment from "moment";
import Head from "@/Molecules/Inertia/Head";
import styles from './PersonRedirect.module.scss'

export default ({person, personUrl, redirectUrl, ziggy}: PageProps<{
  person: Person,
  personUrl: string
  redirectUrl: string
  ziggy: {
    location: string
  },
}>) => {

  const deceasedDateString = person.deceased_date ? '&#10013; ' + moment(person.deceased_date).format('LL') : ''
  const title = `${person.name} ${deceasedDateString} \u2022 overlijdensbericht en condoleances`;
  const metaTags: MetaTag[] = [
    {
      name: 'robots',
      content: 'noindex, follow',
    },
    // OpenGraph
    {
      property: 'og:site_name',
      content: 'Mensenlinq',
    }, {
      property: 'og:locale',
      content: 'nl_NL',
    }, {
      property: 'og:title',
      content: person.name + ' - Mensenlinq',
    }, {
      property: 'og:type',
      content: 'website',
    }, {
      property: 'og:description',
      content: title,
    }, {
      property: 'og:image',
      content: personUrl + '/card.jpg',
    }, {
      property: 'og:url',
      content: redirectUrl,
    },

    // Twitter
    {
      property: 'twitter:card',
      content: 'summary_large_image',
    }, {
      property: 'twitter:title',
      content: person.name + ' - Mensenlinq',
    }, {
      property: 'twitter:description',
      content: title,
    }, {
      property: 'twitter:url',
      content: redirectUrl,
    }, {
      property: 'twitter:image',
      content: personUrl + '/card.jpg',
      // }, {
      //   'http-equiv': 'refresh',
      //   content: `1;url=${url}`,
    }]

  useEffect(() => {
    setTimeout(() => {
      window.location.href = redirectUrl
    }, 1000);
  }, []);
  return <>
    <Head>
      <title>{title}</title>
      {metaTags && metaTags.map((props, index) =>
        <meta key={index} {...props} />
      )}
      <link rel="canonical" href={redirectUrl} />
    </Head>
    <p className={styles.center}>Je wordt doorgestuurd naar <a href={redirectUrl}>{redirectUrl}</a>...</p>

  </>

}
